import WRAP from 'WRAP-JS'
import { configAirportDh, configAirportLayer } from "./config/ConfigAirport";
import { MAP_ID_AIRPORT } from "../../../store/MapContentsState";

class Airport {
  static NAME = MAP_ID_AIRPORT
  dh;
  layer;
  ready = false;

  constructor() {
    this.layer = new WRAP.Geo.Layer(Airport.NAME);
    this.layer.setVisible(false);
    this.layer.setTooltip((geo) => {
      return geo.properties.icao;
    });
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  async initData() {
    return new Promise(resolve => {
      this.dh = new WRAP.Data(configAirportDh);
      this.dh.load('data', null, false, ref => {
        resolve(ref);
      }, _ => {
        throw new Error(`[${Airport.NAME}]: load failed.`)
      });
    });
  }

  initLayer() {
    this.layer.configure(this.dh, configAirportLayer);
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this.layer;
  }

  setVisible(visible) {
    if (!this.ready) return;

    if (this.layer.visible() === visible) {
      return;
    }

    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  changeRoutePointEditing(routePointEditing) {
    this.layer.disableInteraction(routePointEditing);
  }

}

export default Airport;